var app = angular.module('directives.sliderTemplates', []);

require('./directive.js');

module.exports =  app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderTemplates/index.js
 ** module id = 232
 ** module chunks = 1
 **/